<style scoped>
.droplet-container {
}
.droplet {
  white-space: normal;
}
.droplet-inner {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 6px;
  background: #f2f2f2;
  height: 100%;
  width: 100%;
  position: relative;
}
.droplet-name {
  display: block;
  color: #444;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.8rem;
  margin: -3px 0 0;
  height: 28px;
}
.droplet-domain {
  display: block;
  height: 20px;
  width: 100%;
  font-size: 12px;
}
.droplet-id {
  font-weight: normal !important;
  background: #fff;
  padding: 0px 6px;
  border-radius: 6px;
  margin-right: 5px;
  position: relative;
  padding-left: 13px;
}
.droplet-status {
  height: 15px;
  width: 15px;
  border-width: 2px;
  left: -5px;
  top: 2px;
  background: #15cd72;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  overflow: hidden;
}
.droplet-status.offline {
  background: #9c9c9c;
}
.droplet-status.errored {
  background: red;
}
.droplet-version {
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 12px;
}
.droplet-branch {
  position: absolute;
  right: 10px;
  bottom: 30px;
  font-size: 12px;
}
.droplet-infos {
  height: 16px;
}
.droplet-unregistered {
  color: orange;
}
.droplet-menu {
  position: absolute;
  right: 5px;
  top: 5px;
}
.droplet-menu-list > div {
  padding: 5px 20px;
  cursor: pointer;
}
.droplet-menu-list > div:hover {
  background: #f2f2f2;
}
.droplet-menu .v-btn.default {
  background: transparent;
  color: #272727;
  box-shadow: none;
  border: none;
}
.droplet-infos > span:not(:last-child) {
  margin-right: 5px;
  padding-right: 5px;
  border-right: 1px solid #ccc;
}
.droplet-infos {
  font-size: 12px;
}
.droplet-infos i {
  font-size: 14px;
}
.update-failed .droplet-inner {
  background: #ffb2b2;
}
.update-success .droplet-inner {
  background: #b2ffb2;
}
.droplet-loading {
  margin-top: 11px;
  padding-bottom: 40px;
}
</style>
<template>
  <div>
    <v-container fluid>
      <titleBlock
        title="Droplet Listesi"
        description="Dropletleri listeleyebilir, düzenleyebilir lisans bilgilerini değiştirebilirsiniz."
      />
      <v-card>
        <div
          v-if="droplets.length > 0"
          class="droplet-container row"
          style="min-height: 500px; padding: 20px"
        >
          <div
            class="droplet col-4"
            :class="[
              droplet.updateFailed ? 'update-failed' : '',
              droplet.updateSuccess ? 'update-success' : '',
            ]"
            v-for="droplet in droplets"
            :key="droplet.id"
          >
            <div class="droplet-inner">
              <label class="droplet-name"
                ><span title="Droplet Numarası" class="droplet-id"
                  >{{ droplet.id }}
                  <i
                    class="droplet-status"
                    :class="[droplet.status == 'active' ? 'active' : 'offline']"
                  ></i
                ></span>
                {{ droplet.name }}</label
              >
              <a
                target="_blank"
                class="droplet-domain"
                :href="'https://' + droplet.domain"
                >{{ droplet.domain }}</a
              >
              <label class="droplet-branch">Master</label>
              <label class="droplet-version">{{
                droplet.version || "0.0.0.0"
              }}</label>
              <div class="droplet-infos">
                <span v-if="!droplet.registered"
                  ><i
                    title="Droplet Doğrulanmamış"
                    class="mdi mdi-alert-circle"
                  ></i
                ></span>
                <span v-if="droplet.updateFailed"
                  ><i
                    title="Droplet Güncellenemedi"
                    class="mdi mdi-alert-circle"
                  ></i
                ></span>
                <span class="droplet-userCount" title="Müşteri Sayısı">
                  <i class="mdi mdi-account-group"></i>
                  {{ droplet.userCount }}</span
                >
              </div>
              <div v-if="droplet.loading" class="droplet-loading">
                <v-progress-linear
                  color="deep-purple accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
              <div class="droplet-menu">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="default" dark v-bind="attrs" v-on="on">
                      <i class="mdi mdi-cog"></i>
                    </v-btn>
                  </template>
                  <v-list class="droplet-menu-list">
                    <v-list-item-title> Yeniden Başlat </v-list-item-title>
                    <v-list-item-title
                      @click="
                        selectedDroplet = droplet;
                        openCollapse();
                      "
                    >
                      Güncelle
                    </v-list-item-title>
                    <v-list-item-title> Kapatmaya Zorla </v-list-item-title>
                    <v-list-item-title> Branş Değiştir </v-list-item-title>
                    <v-list-item-title v-if="!droplet.registered">
                      Doğrula
                    </v-list-item-title>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>
    <!--collapse-panel-->
    <div @click="closeCollapse" class="collapse-panel-overlay"></div>
    <div
      v-if="selectedDroplet"
      id="collapse-droplet-update"
      class="collapse-panel"
    >
      <div class="collapse-panel-inner">
        <div class="collapse-panel-head">
          <label>Güncelleme Gönder</label>
          <p>
            Release için yaptığınız değişiklikler yayına alınacaktır. Lütfen
            zorunlu alanları eksiksiz doldurunuz.
            <br />
            <br />Droplet :
            <a :href="'https://' + selectedDroplet.domain"
              >https://{{ selectedDroplet.domain }}</a
            >
            <br />Versiyon :
            <strong>{{ selectedDroplet.version || "0.0.0.0" }}</strong>
          </p>
          <i @click="closeCollapse" class="collapse-close mdi mdi-close"></i>
        </div>
        <div class="collapse-panel-body">
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="versionUpdate.customerInfo"
                flat
                label="Müşteri bilgilendirildi mi?"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="versionUpdate.npmPackage"
                flat
                label="NPM Paketleri güncellensin mi?"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="versionUpdate.restart"
                flat
                label="Güncelleme atıldıktan sonra yeniden başlatılsın mı?"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="versionUpdate.dbAlter"
                flat
                label="Veritabanı tablolarında değişiklik yapıldı mı?"
              ></v-switch>
            </v-col>
            <v-col v-if="versionUpdate.dbAlter" cols="12">
              <v-switch
                v-model="versionUpdate.dbSyncCompleted"
                flat
                label="Veritabanı senkronizasyonu yapıldı mı?"
              ></v-switch>
            </v-col>
            <v-col cols="12">
              <div>
                <v-btn
                  @click="sendUpdate(selectedDroplet, versionUpdate)"
                  class="wfull"
                  color="primary"
                  >Güncelleme Gönder</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <!--collapse-panel-->
  </div>
</template>
<script>
import Vue from "vue";
import { mapActions } from "vuex";
import titleBlock from "./../../../components/layout/TitleBlock.vue";
import mixin from "./../../../lib/mixins";
export default Vue.extend({
  mixins: [mixin],
  data() {
    return {
      language: this.$root.localization.data,
      droplets: [],
      selectedDroplet: null,
      versionUpdate: {
        customerInfo: false,
        dbAlter: false,
        dbSyncCompleted: false,
        comment: null,
        restart: false,
        npmPackage: false,
      },
    };
  },
  methods: {
    ...mapActions({
      getDroplets: "admin/getDroplets",
      sendUpdateToDroplet: "admin/sendUpdateToDroplet",
    }),
    refreshDroplets() {
      var self = this;
      self.getDroplets().then((r) => {
        var droplets = r.data.data;
        for (var droplet of droplets) {
          droplet.userCount = droplet.users.length;
          droplet.updateFailed = false;
          droplet.updateSuccess = false;
          droplet.loading = false;
        }
        self.droplets = droplets;
      });
    },
    sendUpdate(droplet, versionUpdate) {
      var self = this;
      self.closeCollapse();
      droplet.loading = true;
      self
        .sendUpdateToDroplet({ droplet, versionUpdate })
        .then((r) => {
          var urlDecode = new URL(r.config.url);
          var droplet = self.droplets.find(
            (x) => x.domain.toLowerCase() == urlDecode.hostname.toLowerCase()
          );
          if (droplet) {
            droplet.updateFailed = false;
            droplet.updateSuccess = true;
            droplet.loading = false;
          }
        })
        .catch((r) => {
          var urlDecode = new URL(r.config.url);
          var droplet = self.droplets.find(
            (x) => x.domain.toLowerCase() == urlDecode.hostname.toLowerCase()
          );
          if (droplet) {
            droplet.updateSuccess = false;
            droplet.updateFailed = true;
            droplet.loading = false;
          }
        });
    },
  },
  components: {
    titleBlock,
  },
  created() {
    var self = this;
    self.refreshDroplets();
  },
  mounted() {},
});
</script>